import { API_URL } from '../../constants/config'
import i18n from '../../services/i18n'
import { getSessionId, getTraceId } from '../../util/sentry'
import { getToken } from '../auth'

import { handleUnauthorizedRequest } from './utils/helper'

interface FetcherOptions {
  auth?: boolean
  body?: BodyInit
  method?: string
}

export async function apiFetcher<T>(endpoint: string, opts: FetcherOptions = {}): Promise<T> {
  const headers = new Headers()
  const { auth = false, method = 'GET', body } = opts

  if (auth) {
    const jwt = await getToken()
    headers.append('Authorization', 'Bearer ' + jwt)
  }

  headers.append('x-locale', i18n.language)
  headers.append('x-session-id', (await getSessionId()) ?? '')
  headers.append('x-trace-id', getTraceId())
  headers.append('x-app', 'patient')
  headers.append('Content-Type', 'application/json')

  const resp = await fetch(`${API_URL}${endpoint}`, {
    headers,
    method,
    body,
  })

  handleUnauthorizedRequest(resp.status).then()

  const data = await resp.json()

  if (!resp.ok) {
    throw data
  }

  return data
}
